<template>
  <div
    class="document-container"
    :class="{ 'document-page': accessByLink, 'submit-clicked': submitClicked }"
    ref="document"
  >
    <img
      v-if="!isHideAgencyLogo"
      :src="$store.getters.agencyPublic.logo"
      width=""
      height="80px"
      :alt="$store.getters.agencyPublic.human_name"
      class="center mb-4"
    />
    <h3 class="document-header">{{ document.name || document.title }}</h3>
    <hr />
    <div v-if="document.use_image">
      <div v-if="document.params && document.params.pages">
        <div
          class="doc-page-container"
          v-for="(page, index) of document.params.pages"
          :key="'page-' + index"
        >
          <img
            :src="convertToAbsolutePath(page.url)"
            :style="{
              width: page.size ? page.size.width + 'px' : null,
              height: page.size ? page.size.height + 'px' : null,
            }"
          />
          <div v-if="page.fields">
            <div
              v-for="(field, fieldIndex) of page.fields"
              :key="'field-' + fieldIndex"
              class="doc-field"
              :style="getStylePosition(field)"
            >
              <DocumentField
                :field="field"
                :user="user"
                :isDisable="['Signed', 'Saved'].includes(document.status)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div
        v-html="documentContent"
        :class="submitClicked ? 'submit-clicked' : ''"
      ></div>
      <div class="row">
        <div
          :class="
            document.signer_labels.length % 2 === 0 ? 'col-lg-6' : 'col-lg-12'
          "
          class="sign-section"
          v-for="(signer_label, index) in document.signer_labels"
          :key="'Signer' + index"
        >
          <div>
            <p style="font-weight: 600; margin-bottom: 0">{{ signer_label }}</p>
            <p>{{ getSigningDate(index) }}</p>
            <div v-if="useSignaturePad">
              <SignaturePad
                height="200px"
                width="100%"
                :isViewOnly="isViewOnly"
                v-model="listDrawSignatures[index]"
              />
            </div>
            <div>
              <h4
                v-if="signatures[index]"
                style="font-family: 'Arizonia' !important"
              >
                {{ signatures[index] }}
              </h4>
              <h4 v-if="!signatures[index] && !isViewOnly">___________</h4>
              <div v-if="!isViewOnly">
                <input
                  type="text"
                  class="form-control"
                  v-model="signatures[index]"
                  v-if="!isSignerDisable(index)"
                />
                <label class="mt-1" v-if="!isSignerDisable(index)">
                  {{ getLabelByKeys("DESCRIPTIONS.TYPE_YOUR_NAME_TO_SIGN") }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <label class="col-lg-12 warning-text" v-if="isAgent && !preview">
          People must sign documents themselves, they cannot be signed by
          admins.
        </label>
      </div>
    </div>
    <div
      class="mt-3 mb-3"
      v-if="
        !document.deactivated &&
        (!document.status || document.status.includes('Unsigned')) &&
        !$store.getters.loadingReqNumber
      "
    >
      <label
        class="warning-text admin-sign-warning"
        v-if="document.use_image && isAgent && !preview"
      >
        People must sign documents themselves, they cannot be signed by admins.
      </label>
      <div class="button-containers">
        <div class="preserve-spaces">
          <button
            v-if="hasCancelBtn && !preview"
            class="mylisting-button secondary-button cancel-button"
            @click="handleClickCancelButton()"
          >
            {{ getLabelByKeys("BUTTONS.CANCEL") }}
          </button>
        </div>
        <div class="main-buttons">
          <button
            v-if="!isAgent && document.use_image"
            class="submit-button mylisting-button dark-button sign-button"
            data-index="1"
            @click="sign()"
          >
            {{ getLabelByKeys("BUTTONS.SIGN") }}
          </button>
          <button
            v-else-if="
              !isAgent &&
              document.signer_labels &&
              document.signer_labels.length
            "
            class="submit-button mylisting-button dark-button sign-button"
            data-index="1"
            @click="sign()"
          >
            {{ getLabelByKeys("BUTTONS.SIGN") }}
          </button>
          <button
            v-else-if="!isAgent"
            class="submit-button mylisting-button dark-button sign-button"
            data-index="1"
            @click="saveSign()"
          >
            Complete
          </button>
          <button
            v-if="
              $store.getters.isAgent &&
              document.fields_labels &&
              document.fields_labels.length
            "
            class="mylisting-button dark-button mt-3"
            @click="save()"
          >
            Update (Admin Only)
          </button>
        </div>
      </div>
    </div>
    <div v-if="document && document.organization_signer">
      <p style="font-weight: 600; margin-top: 25px; margin-bottom: 0">
        {{ $store.getters.agency.human_name }}
      </p>
      <p v-if="document.status == 'Unsigned'">
        {{ new Date().toDateString() }}
      </p>
      <p v-if="document.status == 'Signed'">
        {{ new Date(document.signing_date).toDateString() }}
      </p>
      <h4
        v-if="document.organization_signer"
        style="font-family: 'Arizonia' !important"
      >
        {{ document.organization_signer }}
      </h4>
      <p>Per: {{ document.organization_signer }}</p>
    </div>
    <div
      id="ignorePDF"
      v-if="
        !(
          !document.deactivated &&
          (document.status === 'Unsigned' || !document.status) &&
          !$store.getters.loadingReqNumber
        )
      "
    >
      <hr />
      <button
        v-if="hasCancelBtn"
        class="mylisting-button secondary-button cancel-button"
        @click="$emit('cancel')"
      >
        {{ getLabelByKeys("BUTTONS.CLOSE") }}
      </button>
      <button
        v-if="document.status == 'Signed' || document.status == 'Saved'"
        class="mylisting-button dark-button float-right"
        @click="downloadPDF()"
      >
        Download PDF
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  REGEX_SPLIT_FIELD,
  REGEX_MATCH_TEXT_FIELD,
} from "../../../constants/regex";
import html2pdf from "html2pdf.js";
import { mapActions, mapGetters } from "vuex";
import DocumentField from "./DocumentField.vue";
import SignaturePad from "./SignaturePad.vue";
import { STRIPE_PAYMENT_ERROR_IDS } from "../../../constants/custom-define-type";

export default {
  name: "SignDocument",
  components: {
    DocumentField,
    SignaturePad,
  },
  props: {
    documents: {
      type: Array,
      default: () => [],
    },
    passedUser: Object,
    passedDocument: Object,
    isSentRequest: {
      // Send request to save in DB
      type: Boolean,
      default: true,
    },
    hasCancelBtn: {
      type: Boolean,
      default: false,
    },
    preview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      document: {},
      user: {},
      fields: [],
      signatures: [],
      listDrawSignatures: [],
      listCheckboxIds: [],
      listFieldIds: [],
      submitClicked: false,
      isInitValue: false,
      listBlurEventEls: [], // List of element which has custom blur event
      signatureData: null,
      stripe: null,
      elements: null,
      card: null,
      cardError: false,
      isStripeSetup: false,
      unwatch: null,
      paymentInformation: null,
    };
  },
  async created() {
    this.loadProfileBuilderList();
    if (this.preview && this.passedDocument) {
      this.document = this.passedDocument;
    } else if (this.passedUser && this.passedDocument) {
      this.user = this.passedUser;
      this.document = this.passedDocument;
      // Replace all instances of the auto fill fields
      this.document.body = await this.getDocumentBodyFromTemplate(
        this.document,
        this.user
      );
      this.initData();
    } else if (this.accessByLink) {
      this.user.id = this.$route.params.userid;
      this.loadDocument();
    }
    this.unwatch = this.$store.watch(
      (state) => state.agency.agencyPublic,
      (val) => {
        if (!val) {
          return;
        }
        this.setUpStripe();
      },
      { immediate: true }
    );
  },
  updated() {
    this.handleDisplayFieldValue();
  },
  beforeDestroy() {
    for (const el of this.listBlurEventEls) {
      el.removeEventListener("blur", this.cloneFieldValues);
    }
    if (this.unwatch) {
      this.unwatch();
    }
  },
  computed: {
    ...mapGetters([
      "isAgent",
      "updateClientStatusWhenAllDocumentSigned",
      "updateCandidateStatusWhenAllDocumentSigned",
      "clientStatusToUpdateWhenAllDocumentSigned",
      "candidateStatusToUpdateWhenAllDocumentSigned",
      "userDocuments",
      "userDocumentsErrors",
      "isAgent",
    ]),
    stripeCardId() {
      return "stripe-card-document";
    },
    isHideAgencyLogo() {
      return this.tryGet(
        () =>
          this.document.hide_agency_logo ||
          this.document.template_data.hide_agency_logo
      );
    },
    useSignaturePad() {
      return this.tryGet(
        () =>
          this.document.use_signature_pad ||
          this.document.template_data.use_signature_pad
      );
    },
    isViewOnly() {
      if (!this.document) {
        return true;
      }
      if (!this.document.status) {
        return false;
      }
      if (this.document.status === "Unsigned") {
        return false;
      }
      if (
        this.document.status === "CandidateUnsigned" &&
        this.user.is_candidate
      ) {
        return false;
      }
      return true;
    },
    accessByLink() {
      return this.$route.params.documentid && this.$route.params.hashId;
    },
    documentContent() {
      if (this.document == null || this.user == null) {
        return "";
      }
      const documentBody = this.document.body;
      if (!documentBody) {
        return "";
      }
      let result = documentBody;
      const listTags = this.extractTagFromString(documentBody, true);
      this.listCheckboxIds = [];
      this.listFieldIds = [];
      for (let index = 0; index < listTags.length; index++) {
        const tag = listTags[index];
        // Checkbox field
        if (tag.indexOf("x ") === 0) {
          const checkboxId =
            (this.document.title || this.document.name) + "-xcheckbox-" + index;
          this.listCheckboxIds.push(checkboxId);
          const checkboxLabel = tag.substring(2).trim();
          if (
            this.isViewOnly ||
            (this.document.status === "CandidateUnsigned" &&
              this.user.is_candidate)
          ) {
            result = this.replaceAllText(
              result,
              `[[${tag}]]`,
              `<div>${checkboxLabel}</div>`
            );
          } else {
            result = this.replaceAllText(
              result,
              `[[${tag}]]`,
              `<div class="form-check">
            <input type="checkbox" id="${checkboxId}" class="form-check-input is-required" required/> 
            <label for="${checkboxId}" class="form-check-label">${checkboxLabel}</label></div>`
            );
          }
          continue;
        }
        // Textbox fields
        const match = `[[${tag}]]`.match(REGEX_MATCH_TEXT_FIELD);
        if (!match) {
          continue;
        }

        const fieldIndex = Number(tag.replace("field", "").trim());
        // Check if the field is view only or editable
        const isViewOnly = this.isViewOnlyField(fieldIndex);

        if (isViewOnly) {
          // Only display data
          let displayValue = this.fields[fieldIndex];
          if (this.isCheckboxField(fieldIndex)) {
            if (displayValue) {
              // Checked
              displayValue = `<div style="display: flex; align-items: center;">
              <span class="material-icons">check_box</span><span class="ml-1">${displayValue}</span></div>`;
            } else {
              // Unchecked
              const fieldLabel = this.preview
                ? this.document.fields[fieldIndex]
                : this.document.fields_labels[fieldIndex];
              displayValue = `<div style="display: flex; align-items: center;">
              <span class="material-icons">check_box_outline_blank</span><span class="ml-1">${fieldLabel}</span></div>`;
            }
          } else if (this.isRadioGroupField(fieldIndex)) {
            const field = this.document.list_fields[fieldIndex];
            const fieldLabel = this.preview
              ? this.document.fields[fieldIndex]
              : this.document.fields_labels[fieldIndex];
            const listOptionElContent = this.normalizedArrayValue(
              field.option_list
            )
              .map(
                (option) => `<div style="display: flex; align-items: center;">
              <span class="material-icons" style="width: 1em;">${
                option === displayValue
                  ? "radio_button_checked_icon"
                  : "radio_button_unchecked_icon"
              }</span><span class="ml-1">${option}</span></div>`
              )
              .join("\n");
            if (fieldLabel) {
              displayValue = `<div>${fieldLabel}</div>${listOptionElContent}`;
            } else {
              displayValue = listOptionElContent;
            }
          } else if (this.isStripePaymentField(fieldIndex)) {
            const paymentInfo = this.document.payment_info;
            if (!paymentInfo) {
              displayValue = "";
            } else {
              const fieldLabel = this.preview
                ? this.document.fields[fieldIndex]
                : this.document.fields_labels[fieldIndex];
              const summaryPaymentInfo = `<div>Card Info: Ending with ${paymentInfo.last4}, Exp date:
            ${paymentInfo.exp_year}-${paymentInfo.exp_month}</div>`;
              if (fieldLabel) {
                replaceContent = `<div>${fieldLabel}</div>${summaryPaymentInfo}`;
              } else {
                replaceContent = summaryPaymentInfo;
              }
            }
          } else {
            if (displayValue == null) {
              displayValue = "";
            } else {
              displayValue = `<span style="margin: 0.5em;">${displayValue}</span>`;
            }
          }
          result = this.replaceAllText(result, `[[${tag}]]`, displayValue);
        } else {
          let replaceContent;
          let fieldId;
          if (this.isCheckboxField(fieldIndex)) {
            fieldId =
              (this.document.title || this.document.name) +
              "-checkbox-" +
              index;
            const fieldLabel = this.preview
              ? this.document.fields[fieldIndex]
              : this.document.fields_labels[fieldIndex];
            if (this.document.fields_required[fieldIndex]) {
              replaceContent = `<div class="form-check">
            <input type="checkbox" id="${fieldId}" value="${fieldLabel}" class="form-check-input is-required" required/> 
            <label for="${fieldId}" id="${
                fieldId + "-label"
              }" class="form-check-label">${fieldLabel}</label></div>`;
            } else {
              replaceContent = `<div class="form-check">
            <input type="checkbox" id="${fieldId}" value="${fieldLabel}" class="form-check-input"/> 
            <label for="${fieldId}" id="${
                fieldId + "-label"
              }" class="form-check-label">${fieldLabel}</label></div>`;
            }
          } else if (this.isRadioGroupField(fieldIndex)) {
            fieldId =
              (this.document.title || this.document.name) +
              "-radio-group-" +
              index;
            const field = this.document.list_fields[fieldIndex];
            console.log(field);
            const selectedValue = this.document.fields[fieldIndex];
            const fieldLabel = this.preview
              ? this.document.fields[fieldIndex]
              : this.document.fields_labels[fieldIndex];
            const isRequired = this.document.fields_required[fieldIndex];
            const listOptionElContent = this.normalizedArrayValue(
              field.option_list
            )
              .map(
                (option, optionIndex) => `<div class="form-check">
            <input type="radio" id="${
              fieldId + "option" + optionIndex
            }" value="${option}" class="form-check-input ${
                  isRequired ? "is-required" : ""
                }" ${isRequired ? "required" : ""} ${
                  selectedValue === option ? "checked" : ""
                } name="${fieldId}"/> 
            <label for="${fieldId + "option" + optionIndex}" id="${
                  fieldId + "option" + optionIndex + "-label"
                }" class="form-check-label">${option}</label></div>`
              )
              .join("\n");
            if (fieldLabel) {
              replaceContent = `<div>${fieldLabel}</div>${listOptionElContent}`;
            } else {
              replaceContent = listOptionElContent;
            }
          } else if (this.isStripePaymentField(fieldIndex)) {
            const isFieldRequired = this.document.fields_required[fieldIndex];
            const stripeCardEl = `<div id="${this.stripeCardId}" class="${
              isFieldRequired ? "is-required" : ""
            }" style="margin-top: 0.5em">
            </div>
            <div
              class="mt-2"
              id="card-document-errors"
              role="alert"
              style="font-size: 1rem; font-weight: 700; color: red"
            ></div>`;
            const fieldLabel = this.preview
              ? this.document.fields[fieldIndex]
              : this.document.fields_labels[fieldIndex];
            if (fieldLabel) {
              replaceContent = `<div>${fieldLabel}</div>${stripeCardEl}`;
            } else {
              replaceContent = stripeCardEl;
            }
          } else {
            let placeHolder = "";
            if (
              this.document.list_fields &&
              this.document.list_fields[fieldIndex] &&
              this.document.list_fields[fieldIndex].place_holder
            ) {
              placeHolder = `placeholder="${this.document.list_fields[fieldIndex].place_holder}" `;
            }
            // Editable field
            fieldId =
              (this.document.title || this.document.name) + "-input-" + index;
            replaceContent = `<textarea class="form-control signing-field signing-field-${fieldIndex}" ${placeHolder}rows="1" id="${fieldId}"></textarea>`;
            if (this.document.fields_required[fieldIndex]) {
              replaceContent = `<textarea class="form-control signing-field is-required signing-field-${fieldIndex}" required ${placeHolder}rows="1" id="${fieldId}"></textarea>`;
            }
            // Replace first occurrence (In case 1 fields appear in multiple place, only first occurence is required)
            result = result.replace(`[[${tag}]]`, replaceContent);
            if (this.document.fields_required[fieldIndex]) {
              replaceContent = `<textarea class="form-control signing-field signing-field-${fieldIndex}" ${placeHolder}rows="1" id="${fieldId}"></textarea>`;
            }
          }
          result = this.replaceAllText(result, `[[${tag}]]`, replaceContent);
          this.listFieldIds[fieldIndex] = fieldId;
        }
      }
      return result;
    },
  },
  methods: {
    ...mapActions(["getDocumentsByUserID"]),
    handleDisplayFieldValue() {
      if (this.isInitValue) {
        return;
      }
      if (this.isViewOnly) {
        return;
      }
      if (!this.fields.length) {
        return;
      }
      // Check if list field id is loaded
      const checkedFieldId = this.listFieldIds.find((field) => field != null);
      if (!checkedFieldId) {
        return;
      }
      // Check if element is rendered
      const checkedElement = document.getElementById(checkedFieldId);
      if (!checkedElement) {
        return;
      }
      for (let index = 0; index < this.fields.length; index++) {
        if (this.fields[index]) {
          const element = document.getElementById(this.listFieldIds[index]);
          if (!element) {
            continue;
          }
          element.value = this.fields[index];
        }
      }
      this.isInitValue = true;
    },
    getStylePosition(pos) {
      return {
        top: Math.min(pos.startY, pos.endY) + "px",
        left: Math.min(pos.startX, pos.endX) + "px",
        width: Math.abs(pos.endX - pos.startX) + "px",
        height: Math.abs(pos.endY - pos.startY) + "px",
      };
    },
    isCheckboxField(fieldIndex) {
      return (
        this.document.list_fields &&
        this.document.list_fields[fieldIndex] &&
        this.document.list_fields[fieldIndex].type === "Checkbox"
      );
    },
    isRadioGroupField(fieldIndex) {
      return (
        this.document.list_fields &&
        this.document.list_fields[fieldIndex] &&
        this.document.list_fields[fieldIndex].type === "Radio Group"
      );
    },
    isStripePaymentField(fieldIndex) {
      return (
        this.document.list_fields &&
        this.document.list_fields[fieldIndex] &&
        this.document.list_fields[fieldIndex].type ===
          "Stripe Payment Information"
      );
    },
    isAdminOnlyField(fieldIndex) {
      return (
        this.document.list_fields &&
        this.document.list_fields[fieldIndex] &&
        this.document.list_fields[fieldIndex].is_admin_only
      );
    },
    isViewOnlyField(fieldIndex) {
      let isViewOnly = false;
      if (this.isViewOnly) {
        // View signed document
        isViewOnly = true;
      } else if (this.document.sign_by_both) {
        const isCandidateFill =
          this.document.list_fields &&
          this.document.list_fields[fieldIndex] &&
          this.document.list_fields[fieldIndex].fill_by === "Candidate";
        // Candidate can edit candidate's field, similar with client
        if (
          (this.user.is_candidate && isCandidateFill) ||
          (this.user.is_employer && !isCandidateFill)
        ) {
          isViewOnly = false;
        } else {
          isViewOnly = true;
        }
      }
      if (!this.isAgent && this.isAdminOnlyField(fieldIndex)) {
        return true;
      }
      return isViewOnly;
    },
    getCheckboxLabelFromSegment(content) {
      return content.substring(3, content.length - 2).trim();
    },
    initData() {
      if (this.preview && this.document.list_fields.length) {
        this.fields = this.document.list_fields;
      } else if (this.document.fields.length) {
        this.fields = this.document.fields;
      } else {
        this.fields = [];
      }

      if (this.document.signers) {
        this.signatures = this.document.signers;
      } else {
        this.signatures = [];
      }
      this.listDrawSignatures = this.document.signatures || [];

      setTimeout(() => {
        const listFieldIndex = Object.keys(this.listFieldIds);
        for (const index of listFieldIndex) {
          const els = document.getElementsByClassName(`signing-field-${index}`);
          // If one field appear multiple times, when user fill it in one place, auto fill for other places
          if (els.length > 1) {
            for (let i = 0; i < els.length; i++) {
              const el = els[i];
              el.addEventListener("blur", this.cloneFieldValues, true);
              this.listBlurEventEls.push(el);
            }
          }
        }
      }, 100);
      this.$nextTick(() => {
        this.handleDisplayFieldValue();
        this.setUpStripe();
      });
    },
    // If there are fields with same ids (ex: field0), when one field is fill, clone the value to other fields
    cloneFieldValues(e) {
      if (!e || !e.target || !e.target.className) {
        return;
      }
      const classList = e.target.className.split(" ");
      const signingFieldClass = classList.find((aClass) =>
        aClass.includes("signing-field-")
      );
      if (!signingFieldClass) {
        return;
      }
      const els = document.getElementsByClassName(signingFieldClass);
      const value = e.target.value;
      for (let j = 0; j < els.length; j++) {
        els[j].value = value;
      }
    },
    async loadDocument() {
      // This is for the use case when visiting a document link
      const res = await axios.get(
        `/api/documents/${this.$route.params.documentid}/`
      );
      this.document = res.data;
      if (this.accessByLink) {
        const res2 = await axios.post("/return-public-user/", {
          id: this.$route.params.hashId,
        });
        if (!res2 || !res2.data) {
          return;
        }
        this.user = res2.data.user;
        this.$store.dispatch("setAgencyID", this.user.agency_id);
        await this.loadProfileBuilderList();
      }
      // Replace all instances of the auto fill fields
      this.document.body = await this.getDocumentBodyFromTemplate(
        this.document,
        this.user
      );
      this.initData();
    },

    async sign() {
      this.submitClicked = true;
      this.setFieldsData();
      if (this.hasMissingFields()) {
        this.showErrorDialog(
          this.$store.getters.missingRequiredFieldSigningErrorDialog
        );
        return;
      }
      // handle stripe field
      const isSuccess = await this.createStripeCustomer();
      if (!isSuccess) {
        return;
      }
      if (this.hasMissingSignature()) {
        this.showErrorDialog(this.$store.getters.missingSignatureErrorDialog);
        return;
      }
      //new_signature flag prompts backend to get ip_address, used so that ip_address field is changed only when a signature is submitted and not by anyother update
      if (this.isSentRequest) {
        let requestBody = {
          signers: this.signatures,
          signatures: this.listDrawSignatures,
          signing_date: this.todayDatetimeDjangoFormat,
          fields: this.fields,
          status: "Signed",
          new_signature: true,
        };
        let newUserStatus = this.document.status_to_update_to;
        if (this.document.sign_by_both) {
          if (this.user.is_employer) {
            requestBody = {
              signers: this.signatures,
              signatures: this.listDrawSignatures,
              signing_date: this.todayDatetimeDjangoFormat,
              fields: this.fields,
              body: this.document.body,
              status: "ClientSigned",
              new_signature: true,
            };
            newUserStatus = null;
          } else {
            requestBody = {
              signers: this.signatures,
              signatures: this.listDrawSignatures,
              signing_date2: this.todayDatetimeDjangoFormat,
              fields: this.fields,
              status: "Signed",
              new_signature: true,
            };
          }
        }
        if (this.document.use_image) {
          requestBody.params = this.document.params;
        }
        if (this.user.is_employer) {
          requestBody.is_employer = true;
        } else {
          requestBody.is_candidate = true;
        }
        if (this.paymentInformation) {
          requestBody.payment_info = this.paymentInformation;
        }
        const res = await axios.patch(
          `/api/documents/${this.document.id}/`,
          requestBody
        );
        if (!res) {
          return;
        }
        if (
          (this.user.is_employer &&
            this.updateClientStatusWhenAllDocumentSigned) ||
          (this.user.is_candidate &&
            this.updateCandidateStatusWhenAllDocumentSigned)
        ) {
          //check if all documents are signed
          await this.getDocumentsByUserID(this.user.id);
          if (this.tryGet(() => this.userDocumentsErrors.length)) {
            return;
          }
          let allDocumentSigned = this.userDocuments.every((document) =>
            this.documentIsSigned(document)
          );
          // when all docs signed, client status update
          if (
            this.user.is_employer &&
            this.clientStatusToUpdateWhenAllDocumentSigned &&
            allDocumentSigned
          ) {
            await this.updateUserStatus(
              this.user,
              this.clientStatusToUpdateWhenAllDocumentSigned,
              this.user,
              false
            );
          }
          // when all docs signed, candidate status update
          if (
            this.user.is_candidate &&
            this.candidateStatusToUpdateWhenAllDocumentSigned &&
            allDocumentSigned
          ) {
            await this.updateUserStatus(
              this.user,
              this.candidateStatusToUpdateWhenAllDocumentSigned,
              this.user,
              false
            );
          }
        } else {
          // default user update status
          if (newUserStatus) {
            await this.updateUserStatus(
              this.user,
              newUserStatus,
              this.user,
              false
            );
          }
        }

        // Show success message
        if (
          this.document.signing_success_message &&
          this.document.signing_success_message.trim()
        ) {
          this.showResultDialog({
            title: this.document.signing_success_message,
          });
        } else {
          this.showResultDialog(this.$store.getters.documentSignedResultDialog);
        }

        this.sendEmailNotification();
        if (this.accessByLink) {
          this.loadDocument();
        }
      }
      this.$emit("documentSigned", {
        body: this.document.body,
        signers: this.signatures,
        signatures: this.listDrawSignatures,
        fields: this.fields,
      });
    },
    sendEmailNotification() {
      // Send notification email
      if (this.document.signing_notification_emails.length) {
        const signatures = this.signatures ? this.signatures.join(", ") : "";
        this.$store.dispatch("sendEmails", {
          subject: `Document Signed - ${signatures} | ${this.document.title}`,
          message:
            "Hello," +
            "\n\n" +
            `${signatures} - ${this.user.first_name} ${this.user.last_name} (${this.user.email}) just signed the following document: ${this.document.title}\n\n` +
            `Login URL: <a target="_blank" href="${this.rootUrl}/login/${this.$store.getters.agencyID}">${this.rootUrl}/login/${this.$store.getters.agencyID}</a>\n\n` +
            "Cheers!",
          from: this.$store.getters.enginehireFromEmail,
          emails: [
            this.$store.getters.enginehireLoggingEmail,
            ...this.document.signing_notification_emails,
          ],
          reply: this.$store.getters.enginehireFromEmail,
          // userID: this.aakashid,
          userID: this.user.id,
        });
      }
    },
    documentIsSigned(document) {
      if (document.status == "Unsigned") {
        return false;
      }
      if (document.sign_by_both) {
        if (document.status === "CandidateUnsigned" && this.user.is_candidate) {
          return false;
        }
      }
      return true;
    },
    async saveSign() {
      this.submitClicked = true;
      this.setFieldsData();
      //
      // This is when a document isn't technically "signed", but just saving information
      // (still want to set the status to signed since that means it's completed)
      //
      if (this.hasMissingFields()) {
        this.showErrorDialog(
          this.$store.getters.missingRequiredFieldSigningErrorDialog
        );
        return;
      }
      const res = await axios.patch(`/api/documents/${this.document.id}/`, {
        fields: this.fields,
        status: "Saved",
      });
      if (res) {
        this.sendEmailNotification();
        this.$emit("documentSigned");
        if (this.accessByLink) {
          this.loadDocument();
        }
      }
    },
    async save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      console.log(isEmpty, data);
      this.setFieldsData();
      //
      // This is for saving a document information without marking it as signed
      // Primarily for admins setting up documents for users to sign
      //
      const res = await axios.patch(`/api/documents/${this.document.id}/`, {
        fields: this.fields,
      });
      if (res) {
        this.$toasted.show("Document saved");
        this.$emit("documentSaved");
      }
    },
    handleClickCancelButton() {
      // Check if not show notitification in application form
      if (this.isDisableConfirmCancellation()) {
        this.$emit("cancel");
        return;
      }
      this.setFieldsData();
      // Check if user fill anything
      if (!this.checkAnyFieldIsFilled()) {
        this.$emit("cancel");
        return;
      }
      this.showConfirmDialog({
        ...this.$store.getters.cancelConfirmDialog,
        onAcceptCallback: () => this.$emit("cancel"),
      });
    },
    checkAnyFieldIsFilled() {
      // Check if any field is filled
      const listFields = this.preview
        ? this.document.fields
        : this.document.fields_labels;
      if (listFields) {
        for (let index = 0; index < listFields.length; index++) {
          if (this.fields[index]) {
            return true;
          }
        }
      }
      // Check any signer is filled
      for (let index = 0; index < this.document.signer_labels.length; index++) {
        if (this.signatures[index]) {
          return true;
        }
        if (this.useSignaturePad) {
          if (this.listDrawSignatures[index]) {
            return true;
          }
        }
      }
      return false;
    },
    setFieldsData() {
      if (this.document && !this.document.sign_by_both) {
        this.fields = [];
      }
      for (let index = 0; index < this.listFieldIds.length; index++) {
        const fieldId = this.listFieldIds[index];
        if (fieldId == null) {
          continue;
        }
        if (this.isRadioGroupField(index)) {
          const checkedEl = document.querySelector(
            `input[name="${fieldId}"]:checked`
          );
          if (checkedEl) {
            this.fields[index] = checkedEl.value;
          } else {
            this.fields[index] = "";
          }
        } else {
          const field = document.getElementById(fieldId);
          if (field) {
            if (this.isCheckboxField(index)) {
              if (field.checked) {
                this.fields[index] = field.value;
              } else {
                this.fields[index] = "";
              }
            } else {
              this.fields[index] = field.value;
            }
          }
        }
      }
      for (let index = 0; index < this.fields.length; index++) {
        if (this.fields[index] == null) {
          this.fields[index] = "";
        }
      }
      console.log(this.fields);
    },
    hasMissingFields() {
      console.log(this.fields);
      // Check all checkbox is filled
      for (const checkboxId of this.listCheckboxIds) {
        const field = document.getElementById(checkboxId);
        if (field && !field.checked) {
          return true;
        }
      }
      // Check all require field is filled
      if (this.document.fields_required) {
        for (let index = 0; index < this.listFieldIds.length; index++) {
          const fieldId = this.listFieldIds[index];
          if (fieldId == null) {
            continue;
          }
          if (this.document.fields_required[index]) {
            if (!this.fields[index]) {
              return true;
            }
          }
        }
      }
      return false;
    },
    hasMissingSignature() {
      if (this.document.use_image) {
        return false;
      }
      // Check all signer is filled
      if (this.document.signer_labels) {
        for (
          let index = 0;
          index < this.document.signer_labels.length;
          index++
        ) {
          if (!this.isSignerDisable(index)) {
            if (!this.signatures[index]) {
              return true;
            }
            if (this.useSignaturePad) {
              if (!this.listDrawSignatures[index]) {
                return true;
              }
            }
          }
        }
      }
      return false;
    },
    downloadPDF() {
      html2pdf(this.$refs.document, {
        margin: 1,
        filename: this.document.title + ".pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { dpi: 192, letterRendering: true },
        jsPDF: { unit: "in", orientation: "portrait" },
        pagebreak: { mode: "avoid-all" },
        margin: [0.7, 0, 0.7, 0],
        html2canvas: { allowTaint: false, useCORS: true },
      });
    },
    isSignerDisable(index) {
      if (this.document.sign_by_both) {
        if (this.preview) {
          return false;
        }

        if (this.user.is_employer) {
          if (
            this.document.signer_types &&
            this.document.signer_types[index] !== "Client"
          ) {
            return true;
          }
        } else if (this.user.is_candidate) {
          if (
            this.document.signer_types &&
            this.document.signer_types[index] !== "Candidate"
          ) {
            return true;
          }
        } else {
          return true;
        }
      }
      return false;
    },
    getSigningDate(index) {
      if (!this.document) {
        return "";
      }
      if (this.document.sign_by_both) {
        if (this.document.signer_types[index] === "Client") {
          if (this.document.signing_date) {
            return this.getDateString(new Date(this.document.signing_date));
          }
        } else {
          if (this.document.signing_date2) {
            return this.getDateString(new Date(this.document.signing_date2));
          }
        }
        if (this.isSignerDisable(index)) {
          return "";
        } else {
          return this.getDateString(new Date());
        }
      } else {
        if (this.document.signing_date) {
          return this.getDateString(new Date(this.document.signing_date));
        } else {
          return this.getDateString(new Date());
        }
      }
    },
    setUpStripe() {
      if (
        !this.$store.getters.agencyPublic ||
        !Object.keys(this.$store.getters.agencyPublic).length
      ) {
        // Not finish loading
        return;
      }
      if (this.isStripeSetup) {
        return;
      }
      // Find the element
      if (!document.getElementById(this.stripeCardId)) {
        return;
      }
      this.isStripeSetup = true;
      this.stripe = Stripe("pk_live_uQWLhWijqTDmzPz1heFX42gd00M0Oov1EL", {
        stripeAccount: this.$store.getters.agencyPublic.stripe_account_id,
      });
      this.elements = this.stripe.elements();
      // this.elements = stripe.elements();

      let style = {
        base: {
          color: "#32325d",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            // color: "#aab7c4",
            color: "#1f4e78",
          },
        },

        invalid: {
          // All of the error styles go inside of here.
          color: "#fa755a",
          iconColor: "#fa755a",
        },
      };

      this.card = this.elements.create("card", { style: style });
      this.card.mount("#" + this.stripeCardId);

      this.card.addEventListener("change", ({ error }) => {
        const displayError = document.getElementById("card-document-errors");
        if (error) {
          displayError.textContent = error.message;
          this.cardError = true;
        } else {
          displayError.textContent = "";
          this.cardError = false;
        }
        this.$nextTick(() => {
          let paymentInfoErrorInnerHtml = "";
          if (this.cardError) {
            paymentInfoErrorInnerHtml = `<span id='${STRIPE_PAYMENT_ERROR_IDS.INVALID}'>Payment information is incorrect</span>`;
          } else {
            if (this.isCardComplete) {
              paymentInfoErrorInnerHtml = "";
            } else {
              paymentInfoErrorInnerHtml = `<span id='${STRIPE_PAYMENT_ERROR_IDS.EMPTY}'>The field is required.</span>`;
            }
          }
          const paymentInfoError =
            document.getElementById("payment-info-error");
          if (paymentInfoError) {
            paymentInfoError.innerHTML = paymentInfoErrorInnerHtml;
          }
        });
      });
    },
    createStripeCustomer() {
      return new Promise(async (resolve) => {
        // Check if stripe element is existed
        const stripeEl = document.getElementById(this.stripeCardId);
        if (!stripeEl) {
          // No Stripe item
          resolve(true);
          return;
        }
        if (stripeEl.classList) {
          if (
            stripeEl.classList.contains("is-required") &&
            stripeEl.classList.contains("StripeElement--empty")
          ) {
            this.showErrorDialog("PAYMENT_INFORMATION_REQUIRED");
            resolve(false);
            return;
          }
          if (stripeEl.classList.contains("StripeElement--invalid")) {
            this.showErrorDialog("PAYMENT_INFORMATION_INVALID");
            resolve(false);
            return;
          }
        }
        let userEmail = this.user.email;
        const userName = `${this.user.first_name} ${this.user.last_name}`;
        const result = await this.stripe.createPaymentMethod({
          type: "card",
          // card: cardElement,
          card: this.card,
          billing_details: {
            email: userEmail,
          },
        });
        if (result.error) {
          const errorMessage = result.error.message
            ? result.error.message
            : JSON.stringify(result.error);
          this.showErrorDialog({
            title: "Error when creating payment method",
            message: errorMessage,
          });
          resolve(false);
          return;
        } else {
          const createCustomerRes = await axios.post(
            "/stripe-create-customer-v2/",
            {
              email: userEmail,
              name: userName,
              enginehire_id: this.user.id,
              payment_method_id: result.paymentMethod.id,
              stripe_account:
                this.$store.getters.agencyPublic.stripe_account_id,
              agency: this.$store.getters.agencyID,
            }
          );
          if (createCustomerRes && createCustomerRes.data) {
            this.paymentInformation = result.paymentMethod.card;
            resolve(true);
            return;
          }
        }
        resolve(false);
      });
    },
  },
};
</script>
<style scoped>
.document-header {
  text-align: center;
}

.document-page {
  margin-top: 120px;
  padding-left: 10%;
  padding-right: 10%;
  padding-bottom: 120px;
}

.button-containers {
  display: flex;
}

.preserve-spaces {
  flex-grow: 1;
}

.doc-page-container {
  width: 100%;
  position: relative;
}

.doc-field {
  position: absolute;
}

label.admin-sign-warning {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/common/documents/SignDocument.vue